module.exports = __webpack_public_path__ + "img/0Q3B0162_L_Black_MockedUp.188b978c.jpg";